module.exports = __webpack_public_path__ + "9b63b7f059c0c7e7fd8994ea7287d416.svg";